import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useState, useEffect } from "react";
import {
  ModalBodyBlack,
  ModalFooterBlack,
  ModalHeaderBlack,
  MyModal,
  RadConnStyle as radStyle,
} from "../../../features/RadConnStyle";
import axios from "axios";
import { HttpJsonHeader } from "../../../features/Environments";
import { FormAuto } from "../../../core/Helper";
import { useDispatch } from "react-redux";
import { setReminder } from "../../../features/UserActions";

export default function GoodsPopup({ props }) {
  const dispatch = useDispatch();
  const [dataX, setDataX] = useState(null);

  // show company for selected
  useEffect(() => {
    if (props.show) {
      axios
        .post(
          process.env.REACT_APP_API + "api/goods/selected-lists",
          {},
          HttpJsonHeader
        )
        .then((res) => {
          setDataX(res.data);
        })
        .catch((err) =>
          dispatch(
            setReminder({ show: true, message: err.message, type: "error" })
          )
        );
    }
  }, [props.show]);

  let rowId = props.fields == null ? -1 : props.fields.GoodId;
  // let pvCmpId = props.fields==null? -1: props.fields.compid;

  const submit = (evt) => {
    let data = {
      GoodId: rowId,
      GoodCode: evt.target.oGoodCode.value,
      GoodName: evt.target.oGoodName.value,
      GoodShort: evt.target.oGoodShort.value,
      GoodUnitId: evt.target.oGoodUnitId.value,
      GoodCateId: evt.target.oGoodCateId.value,
      GdSpcSubId: evt.target.oGdSpcSubId.value,
      GdSpecialtyId: evt.target.oGdSpecialtyId.value,
      GdModId: evt.target.oGdModId.value,
      UpdateBy: props.user.userid,
    };

    if (rowId < 0) {
      data = { ...data, CreateBy: props.user.userid };
    }

    evt.preventDefault();
    axios
      .post(
        process.env.REACT_APP_API + "api/goods/update",
        data,
        HttpJsonHeader
      )
      .then((res) => {
        dispatch(
          setReminder({
            show: true,
            message: "ปรับปรุงเรียบร้อย",
            type: "success",
          })
        );
        props.setUpdate(true);
        props.hidePopup();
      })
      .catch((err) =>
        dispatch(
          setReminder({ show: true, message: err.message, type: "error" })
        )
      );
  };

  const FILED = [
    {
      label: "รหัสสินค้า/บริการ",
      oName: "oGoodCode",
      require: true,
      defaultValue: props.fields == null ? "" : props.fields.GoodCode,
      type: "text",
    },
    {
      label: "ชื่อสินค้า/บริการ",
      oName: "oGoodName",
      require: true,
      defaultValue: props.fields == null ? "" : props.fields.GoodName,
      type: "text",
    },
    {
      label: "ชื่อแบบสั้น",
      oName: "oGoodShort",
      require: true,
      defaultValue: props.fields == null ? "" : props.fields.GoodShort,
      type: "text",
    },

    {
      label: "หน่วยนับ",
      oName: "oGoodUnitId",
      require: true,
      defaultValue: props.fields == null ? "" : props.fields.GoodUnitId,
      type: "select",
      rows: dataX ? dataX.GoodUnit : null,
    },
    {
      label: "ประเภทสินค้า",
      oName: "oGoodCateId",
      require: true,
      defaultValue: props.fields == null ? "" : props.fields.GoodCateId,
      type: "select",
      rows: dataX ? dataX.GoodCate : null,
    },
    {
      label: "Modality",
      oName: "oGdModId",
      require: true,
      defaultValue: props.fields == null ? "" : props.fields.GdModId,
      type: "select",
      rows: dataX ? dataX.GoodModality : null,
    },
    {
      label: "Spacialty",
      oName: "oGdSpecialtyId",
      require: true,
      defaultValue: props.fields == null ? "" : props.fields.GdSpecialtyId,
      type: "select",
      rows: dataX ? dataX.GoodSpc : null,
    },
    {
      label: "SpecialtySub",
      oName: "oGdSpcSubId",
      require: true,
      defaultValue: props.fields == null ? "" : props.fields.GdSpcSubId,
      type: "select",
      rows: dataX ? dataX.GoodSpcSub : null,
    },
  ];

  return (
    <MyModal show={props.show} size="lg" onHide={props.hidePopup} centered>
      <ModalHeaderBlack closeButton>
        เพิ่มแก้ไข {props.formName}
      </ModalHeaderBlack>
      <ModalBodyBlack>
        {FILED ? (
          <FormAuto {...{ formId: "form1", items: FILED, submit: submit }} />
        ) : null}
      </ModalBodyBlack>

      <ModalFooterBlack>
        <Button variant="primary" type="submit" form="form1">
          Save changes
        </Button>
        <Button variant="danger" onClick={props.hidePopup}>
          Close
        </Button>
      </ModalFooterBlack>
    </MyModal>
  );
}
